import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  REGISTRY_MATERIAL_RESOURCE,
  REGISTRY_MATERIAL_RESOURCE_URL,
} from 'SharedDir/backend/endpoints/registry-material-resource';
import { TTP_HISTORY } from 'SharedDir/backend/endpoints/ttp-history';
import { PaginationParams } from 'SharedDir/declarations/pagination';
import { RegistryMaterialResource } from 'SharedDir/declarations/registry-material-resource';
import { QuasarTableExportColumns } from 'SharedDir/declarations/shared';
import { TtpHistory } from 'SharedDir/declarations/ttp-history';

export default class TmcRegistryApiClass extends SimpleApi<
  RegistryMaterialResource.RegistryMaterialResourceFull,
  RegistryMaterialResource.RegistryMaterialResourceCreate,
  RegistryMaterialResource.RegistryMaterialResourceCreate,
  RegistryMaterialResource.RegistryMaterialResourceBare
> {
  constructor() {
    super(REGISTRY_MATERIAL_RESOURCE_URL);
  }

  protected readonly endpoints = REGISTRY_MATERIAL_RESOURCE;

  public async getHistory(id: number, params: any) {
    const endpoint = this.endpoints.HISTORY(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  public async availableStatus() {
    const endpoint = this.endpoints.AVAILABLE_STATUSES;

    const { data } = (await http(endpoint)) as AxiosResponse<{
      data: Record<string, Record<string, string>>;
    }>;

    return data;
  }

  public async provided(
    id: number,
    data: RegistryMaterialResource.RegistryMaterialResourceProvided
  ) {
    const endpoint = this.endpoints.PROVIDED(id);

    const { data: responseData } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<RegistryMaterialResource.RegistryMaterialResourceFull>;

    return responseData;
  }

  public async getMessage(id: number, params: any) {
    const endpoint = this.endpoints.MESSAGE(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<RegistryMaterialResource.MessageTextResponse>;

    return data;
  }

  public async sendMessage(id: number, data: RegistryMaterialResource.MessageText) {
    const endpoint = this.endpoints.SEND_MESSAGE(id);

    const { data: responseData } = (await http({
      ...endpoint,
      data,
    })) as AxiosResponse<RegistryMaterialResource.RegistryMaterialResourceFull>;

    return responseData;
  }

  public async exportAllInBackground<Extra extends object>(
    params: Omit<PaginationParams<object>, 'rowsPerPage' | 'page'> & Extra,
    data: QuasarTableExportColumns
  ) {
    const endpoint = this.endpoints.EXPORT_TABLE_IN_BACKGROUND;

    const { data: responseData } = (await http({
      ...endpoint,
      data,
      params: { ...params, rowsPerPage: 0, page: 1 },
    })) as AxiosResponse<RegistryMaterialResource.RegistryMaterialResourceFull>;

    return responseData;
  }
}
